import { Link } from 'react-router-dom'
import { SITE } from '../data/site.js'
import Icon from '../components/Icon.jsx'

export default function DiyGuide() {
  return (
    <main className="container page page-narrow">
      <nav className="breadcrumbs"><Link to="/">Home</Link> / <span>DIY Guide</span></nav>
      <header className="page-head">
        <h1>DIY installation guide</h1>
        <p>
          Installing your own shower screen or glass panel? These general guidelines will help you plan
          the job safely. For product-specific instructions, always follow the installation sheet
          included with your hardware.
        </p>
      </header>

      <section className="prose policy">
        <h2><Icon name="shield" size={20} /> 1. Is DIY installation right for you?</h2>
        <p>
          Toughened glass panels are heavy, and frameless and semi-frameless screens rely on precise
          hardware alignment to seal and operate properly. If you're not confident working with glass
          and wall fixings, we recommend engaging a licensed glazier or experienced installer — incorrect
          installation is the most common cause of leaks and hardware damage.
        </p>

        <h2><Icon name="check" size={20} /> 2. Before you start</h2>
        <ul>
          <li>Wear safety glasses and gloves when handling glass panels</li>
          <li>Get a second person to help lift and hold panels — never move large glass panels alone</li>
          <li>Make sure tiling and waterproofing are fully finished and cured before fixing hardware to the wall</li>
          <li>Check your wall type (tile, masonry, stud) so you use the correct fixings for your hardware</li>
        </ul>

        <h2><Icon name="box" size={20} /> 3. Tools you'll generally need</h2>
        <ul>
          <li>Spirit level and tape measure</li>
          <li>Drill and appropriate drill bits / wall plugs for your wall type — we stock a 6mm tile core drill bit</li>
          <li>Silicone gun and neutral-cure silicone sealant (wet-area rated)</li>
          <li>Masking tape, for clean straight silicone lines</li>
          <li>Glass suction cups, for safely lifting and positioning panels</li>
          <li>Spacer blocks, to hold panels at the right height while fixing</li>
        </ul>
        <p>
          Most of these are in our <Link to="/shop/tools-accessories">Tools & Accessories</Link> range —
          silicone, suction lifters, spacers, seals and drill bits.
        </p>

        <h2><Icon name="ruler" size={20} /> 4. General installation steps</h2>
        <p>Every hardware set is a little different, so always follow the instructions included with your order. In general:</p>
        <ul>
          <li>Mark and check hinge, bracket or channel positions are level and square before drilling</li>
          <li>Fix wall channels, hinges or brackets securely per the manufacturer instructions supplied with your hardware</li>
          <li>Position the glass panel(s), checking they sit level and any doors swing or slide freely</li>
          <li>Seal all edges with silicone to prevent water leaks, and tool the bead for a clean finish</li>
          <li>Allow the silicone to fully cure (check the tube for cure time) before first use</li>
        </ul>

        <h2><Icon name="tag" size={20} /> 5. A note on warranty</h2>
        <p>
          Our hardware carries a 2-year warranty against manufacturing defects. The warranty is void if
          a product is installed incorrectly, modified or misused — so if anything about the job feels
          outside your comfort zone, engage a qualified installer.
        </p>

        <div className="contact-card">
          <h2>Need help before you order?</h2>
          <p>
            Not sure which configuration fits your space, or what fixings your wall needs? Send us photos
            and rough measurements — advice is free.
          </p>
          <p><Icon name="phone" size={16} /> <a href={SITE.phoneHref}>{SITE.phone}</a></p>
          <p><Icon name="mail" size={16} /> <a href={`mailto:${SITE.email}`}>{SITE.email}</a></p>
          <Link to="/shop/tools-accessories" className="btn btn-primary" style={{ marginTop: 8 }}>
            Shop tools & accessories
          </Link>
        </div>
      </section>
    </main>
  )
}
